import { Controller } from "stimulus";
import UserService from "../entrypoints/src/admin/services/user-service";

export default class extends Controller {
  static targets = ["passwordFields"];

  connect() {
    this.togglePasswordFields();
    this.$inEmail = this.element.querySelector('[data-email-validation]');
    this.$spanEmail = this.element.querySelector('span.email_validation');
    this.$inAccept = this.element.querySelector('input[type="checkbox"].accept');
    !!this.$inAccept && this.$inAccept.addEventListener('change', () => this.updateValidation());
    this.$inEmail.addEventListener('blur', (ev) => this.updateValidation());
  }

  togglePasswordFields() {
    let $skipPassword = this.element.querySelector("#skip-password-validation");
    if (!$skipPassword) return;

    const skipPassword = $skipPassword.checked;
    this.passwordFieldsTarget.style.display = skipPassword ? "flex" : "none";
  }

  updateValidation() {
    const email = this.$inEmail.value.trim();
    const currentEmail = this.$inEmail.dataset.emailValidation;

    if (email.length == 0) {
      this.element.insertAdjacentHTML('afterBegin', `<input type="hidden" name="${this.element.dataset.objectName}[_destroy]" id="user_destroy" value="1">`);
      return this.$inAccept.checked = false;
    } else {
      let input = this.element.querySelector(`#user_destroy`);
      !!input && input.remove();
      this.validateEmail(email, currentEmail);
    }
  }

  async validateEmail(email, currentEmail) {
    if (currentEmail == email || !email)
      return this.$spanEmail.innerHTML = '';

    this.$spanEmail.setAttribute("class", "font-red-flamingo");

    if (!this.isAnEmail(email))
      return this.$spanEmail.innerHTML = 'formato inválido';

    let users = await UserService.where({ queryParams: [`email=${email}`] });
    if (users.length > 0) return this.handelUser(users[0]);

    this.$spanEmail.setAttribute("class", "font-green-jungle");
    this.$spanEmail.innerHTML = this.$inAccept.checked ? 'e-mail disponível' : '';
  }

  handelUser(user) {
    this.$spanEmail.innerHTML = this.$inAccept.checked ? 'e-mail em uso' : '';
    console.log('this.$inAccept', this.$inAccept)
    this.$inEmail.dispatchEvent(new CustomEvent("user-component:selected", { detail: { user: user, usePortal: this.$inAccept.checked }}));
  }

  isAnEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
}
